import { Avatar, Form, Input, Space } from "antd";

export const FormEditGeneralBankInfo = ({ formRef, handleSubmit, isData, confirmLoading, t }) => {

    const bankId = isData?.bank?.bank_id;
    const show = isData?.accountType === "withdrawal"
    return (
        <>
            <Space vertical className="mb-4" size={3}> <Avatar size={24} src={isData?.bank?.imageUrl} /> {t(bankId)} - {isData?.accountNumber} - {isData?.accountName}</Space>
            <Form
                ref={formRef}
                name="edit_general_data_form"
                onFinish={handleSubmit}

                layout="vertical"
                initialValues={{
                    accountName: isData?.accountName || "",
                    accountNumber: isData?.accountNumber || "",
                    telephoneNumber: isData?.telephoneNumber || "",
                    limit_Left: isData?.limit_Left || "0.00",
                    note: isData?.note || "",
                }}
            >
                <Form.Item
                    name="accountName"
                    dependencies={['accountName']}
                    label={t('Account name')}
                    rules={[({ getFieldValue }) => (!getFieldValue('accountName') ? { required: true, message: t('Please enter accountName') } : {})]}
                >
                    <Input disabled={confirmLoading} placeholder="Account name" />
                </Form.Item>
                <Form.Item
                    name="accountNumber"
                    label={t("Account Number")}
                    // normalize จะช่วยกรองค่าทิ้งทันที ไม่ว่าจะพิมพ์หรือ Paste
                    normalize={(value) => value ? value.replace(/\s/g, '').replace(/[^0-9]/g, '') : value}
                    dependencies={['accountNumber']}
                    rules={[
                        ({ getFieldValue }) => (!getFieldValue('accountNumber') ? { required: true, message: t('Please enter only numbers (0-9), no spaces or special characters.') } : {}),
                        {
                            pattern: /^[0-9]+$/,
                            message: t('Please enter only numbers (0-9)!')
                        },
                        // {
                        //     min: 10,
                        //     message: t("Account number must be at least 10 digits")
                        // },
                        {
                            max: 15,
                            message: t("Account number cannot exceed 15 digits")
                        },
                    ]}
                >
                    <Input
                        // maxLength={isData?.bank?.accountLength}
                        disabled={confirmLoading}
                        placeholder={t("Enter numbers only (0-9), no spaces")}
                        // เพิ่มเติม: ป้องกันการกด Space bar
                        onKeyDown={(e) => {
                            if (e.key === " ") {
                                e.preventDefault();
                            }
                        }}
                    />
                </Form.Item>
                {show && (<><Form.Item
                    name="limit_Left"
                    label={t('Maximum account limit')}
                    dependencies={['limit_Left']}
                    style={{ marginBottom: 0 }}
                    rules={[({ getFieldValue }) => (!getFieldValue('limit_Left') ? { required: true, message: t('Please enter limit left') } : {}),]}
                >
                    <Input disabled={confirmLoading} placeholder="Enter limit left" />
                    </Form.Item> 
                    <p className="mt-1 fs-11 text-danger" style={{marginBottom: 24}}>*{t('กรุณาใส่ข้อมูลจริงตามวงเงินที่แสดงในแอพหรือเว็ปไซต์')}</p>
                    </>)}


                <Form.Item
                    name="telephoneNumber"
                    label={t('telephoneNumber')}
                    dependencies={['telephoneNumber']}
                    rules={[({ getFieldValue }) => (!getFieldValue('telephoneNumber') ? { required: true, message: t('Please enter telephoneNumber') } : {}),]}
                >
                    <Input disabled={confirmLoading} placeholder="telephoneNumber" />
                </Form.Item>
                <Form.Item name="note" label={t('note')}>
                    <Input.TextArea disabled={confirmLoading}  rows={3} placeholder={t('Enter note here (Any)')} />
                </Form.Item>

            </Form>
        </>
    )
};